import React, {useState, useEffect} from 'react';

import Modal from '../components/ModalNew';
import Button, {ButtonSizes, ButtonTypes} from '../components/ButtonNew';
import {InterviewTypeIcon} from './InterviewTypeIcon';
import {AIUpsell} from './DuetFeedbackModal';
import {cx} from '../util';
import {InterviewTypes, getInterviewTypesForUser} from '../../../lib/constants/duet';
import {useAppContext, useAnalytics, useWindowSize} from '../hooks';

const MOBILE_WIDTH = 768;

const DESKTOP_ONLY_TYPES = [
  InterviewTypes.Algorithms.key,
  InterviewTypes.SQL.key,
  InterviewTypes['System-Design'].key,
];

// TODO: Standardize component across here and DuetSchedulingModal?
const DuetInterviewType = ({onSelectInterviewType, onClose}) => {
  const {currentUser} = useAppContext();
  const interviewTypes = getInterviewTypesForUser(currentUser?.profile)
    .filter((t) => t.hasAIPractice && !t.disabled);
  const [selectedType, setSelectedType] = useState(interviewTypes[0]?.key);
  const {tracker} = useAnalytics();
  const {width} = useWindowSize();
  const isMobile = width < MOBILE_WIDTH;

  useEffect(() => {
    tracker.duetViewAiSessionModal();
  }, []);

  return (
    <div>
      <div className="md:grid md:gap-3 md:grid-cols-2" role="radiogroup" aria-label="Interview type">
        {interviewTypes.map((interviewType) => {
          if (isMobile && DESKTOP_ONLY_TYPES.includes(interviewType.key)) return null;

          const {badge} = interviewType;

          return (
            <Button
              key={interviewType.key}
              onClick={() => setSelectedType(interviewType.key)}
              buttonType={ButtonTypes.SECONDARY}
              className={cx('relative w-full h-24 mb-3 md:mb-0', {'ring-2 ring-offset-2 ring-indigo-500': selectedType === interviewType.key})}
              role="radio"
              aria-checked={selectedType === interviewType.key}
            >
              {badge && (
                <span className="absolute -top-2 -right-2 whitespace-nowrap rounded-full bg-indigo-600 px-2 py-1 text-xs font-semibold text-white">
                  {badge}
                </span>
              )}
              <div className="w-full pl-3 flex items-center justify-start text-left gap-3">
                <InterviewTypeIcon typeKey={interviewType.key} />
                <div className="flex flex-col">
                  <div className="flex items-center text-lg font-medium leading-5 mb-1">
                    {interviewType.name}
                  </div>
                  <div className="text-gray-500 text-sm leading-tight font-normal">
                    {interviewType.description}
                  </div>
                </div>
              </div>
            </Button>
          );
        })}
      </div>

      <div className="flex justify-end w-full pt-6 gap-2">
        <Button
          buttonType={ButtonTypes.SECONDARY}
          size={ButtonSizes.LARGE}
          className="w-full"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          size={ButtonSizes.LARGE}
          className="w-full"
          onClick={() => onSelectInterviewType(selectedType)}
          disabled={!selectedType}
        >
          Start
        </Button>
      </div>
    </div>
  );
};

const DuetSchedulingModal = ({
  isOpen,
  onClose,
  onCreateAISession,
}) => {
  const {hasAiAccess} = useAppContext();

  return (
    <Modal
      header="Select your AI interviewer"
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton
      modalClassName="max-w-2xl"
    >
      {!hasAiAccess && <AIUpsell />}

      <DuetInterviewType
        onSelectInterviewType={onCreateAISession}
        onClose={onClose}
      />
    </Modal>
  );
};

export default DuetSchedulingModal;
